module.exports = __webpack_public_path__ + "submenu_index_2_active.6ff07e91.png";